import { Translate } from 'react-redux-i18n'

export const TitleComponent = ({ title, style, props }) => {
  return (
    <Translate
      value={title}
      style={{
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '24px',
        color: '#0553A5',
        textTransform: 'uppercase',
        ...style,
      }}
      {...props}
    />
  )
}
